import Reveal from '@/components/base/Reveal';

const capabilities = [
  {
    number: '01',
    icon: 'ri-compass-3-line',
    title: 'Concept Development',
    description: 'Creating restaurant concepts with a clear identity, purpose, and connection to their guests.',
  },
  {
    number: '02',
    icon: 'ri-restaurant-line',
    title: 'Restaurant Operations',
    description: 'Building systems and teams that deliver a consistent hospitality experience every day.',
  },
  {
    number: '03',
    icon: 'ri-line-chart-line',
    title: 'Brand Growth',
    description: 'Developing restaurant brands with the operational foundation needed to grow thoughtfully.',
  },
  {
    number: '04',
    icon: 'ri-team-line',
    title: 'People & Culture',
    description: 'Investing in talented people and creating environments where hospitality teams can do their best work.',
  },
];

export default function WhatWeDo() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.35em] text-primary-600">What We Do</p>
            <h2 className="font-heading text-3xl md:text-5xl mt-6 text-foreground-950 leading-[1.1]">
              From concept to everyday operations.
            </h2>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-background-200 border border-background-200">
          {capabilities.map((item, i) => (
            <Reveal key={item.number} delay={i * 90} className="h-full">
              <div className="bg-background-50 p-8 md:p-9 h-full flex flex-col">
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 flex items-center justify-center text-primary-600">
                    <i className={`${item.icon} text-2xl`}></i>
                  </div>
                  <span className="text-xs tracking-[0.25em] text-foreground-300">{item.number}</span>
                </div>
                <h3 className="font-heading text-xl mt-6 text-foreground-950">{item.title}</h3>
                <p className="mt-3 text-foreground-600 leading-relaxed text-sm">{item.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}